import React, { useState } from "react";
import { useAuth } from "../../AuthContext";
import OrganizationSettings from "./Settings";
import RoleBasedSettings from "./RoleBasedSettings";
import PermissionSettings from "./PermissionSettings";
import OrganizationsList from "./OrganizationsList";
import BulkImportHub from "../BulkImport/BulkImportHub";
import FirebaseAnalytics from "../Analytics/FirebaseAnalytics";
import "./SettingsPage.css";

const SettingsPage = ({ orgId, onOrgIdSelect }) => {
  const { parentOrgId: contextParentOrgId, user } = useAuth();
  const effectiveParentOrgId = contextParentOrgId || user?.parentOrgId || '';
  const isSmallOrg = effectiveParentOrgId === 'SMALLORG-001';

  const [activeTab, setActiveTab] = useState("general");

  const renderTabContent = () => {
    switch (activeTab) {
      case "general":
        return <OrganizationSettings orgId={orgId} />;
      case "roleBased":
        return !isSmallOrg ? <RoleBasedSettings /> : <OrganizationSettings orgId={orgId} />;
      case "permission":
        return !isSmallOrg ? <PermissionSettings /> : <OrganizationSettings orgId={orgId} />;
      case "organizations":
        return !isSmallOrg ? (
          <OrganizationsList
            currentOrgId={orgId}
            onOrgIdSelect={onOrgIdSelect}
          />
        ) : (
          <OrganizationSettings orgId={orgId} />
        );
      case "bulkImport":
        return <BulkImportHub orgId={orgId} />;
      case "analytics":
        return <FirebaseAnalytics embedded={true} orgId={orgId} />;
      default:
        return <OrganizationSettings orgId={orgId} />;
    }
  };

  return (
    <div className="settings-page">
      <main className="main-content">
        <div className="tab-header">
          <button
            className={`tab-button ${activeTab === "general" ? "active" : ""}`}
            onClick={() => setActiveTab("general")}
          >
            General Settings
          </button>

          {!isSmallOrg && (
            <button
              className={`tab-button ${activeTab === "roleBased" ? "active" : ""}`}
              onClick={() => setActiveTab("roleBased")}
            >
              Roles & Permissions
            </button>
          )}

          {!isSmallOrg && (
            <button
              className={`tab-button ${activeTab === "organizations" ? "active" : ""}`}
              onClick={() => setActiveTab("organizations")}
            >
              Organizations
            </button>
          )}

          <button
            className={`tab-button ${activeTab === "bulkImport" ? "active" : ""}`}
            onClick={() => setActiveTab("bulkImport")}
          >
            Data Setup
          </button>

          <button
            className={`tab-button ${activeTab === "analytics" ? "active" : ""}`}
            onClick={() => setActiveTab("analytics")}
          >
            Firebase Analytics
          </button>
        </div>

        <div className="tab-content">
          {renderTabContent()}
        </div>
      </main>
    </div>
  );
};

export default SettingsPage;